export default function wait(length: number): Promise<void> {
    return new Promise(((resolve) => {
        self.setTimeout(() => {
            resolve();
        }, length);
    }));
}
